import axios from 'axios';

const UnderwritingService = {
  async createUnderWriting(formValues) {
    const response = await axios.post('/underwriting', formValues);

    return response.data;
  },

  async updateUnderWriting({ formValues, underwritingId }) {
    const response = await axios.put(
      `/underwriting/${underwritingId}`,
      formValues
    );

    return response.data;
  },
};

export default UnderwritingService;
